"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateOfferItemEvent = exports.Name = void 0;
const Name = exports.Name = 'update-offer-item';
const UpdateOfferItemEvent = exports.UpdateOfferItemEvent = Name;
